module.exports = __webpack_public_path__ + "82925616486d2e6d8edf98ad7192baf0.MP3";